import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import LabsList from "@/components/Lab/LabsList.vue";
import { Prop, Watch } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';
let CustomerLabs = class CustomerLabs extends Vue {
    customerId;
    labs = [];
    fetchLabs;
    currentPage = 1;
    perPage = 20;
    totalRows = 0;
    isLoading;
    mounted() {
        this.refreshData();
    }
    refreshData() {
        this.labs = [];
        this.fetchLabs({
            query: {
                customerId: this.customerId,
                $sort: { createdAt: -1 },
                $limit: this.perPage,
                $skip: (this.currentPage - 1) * this.perPage,
            }
        }).then(data => {
            this.labs = data.data;
            this.totalRows = data.total;
        });
    }
};
__decorate([
    Prop(String)
], CustomerLabs.prototype, "customerId", void 0);
__decorate([
    Watch('currentPage')
], CustomerLabs.prototype, "refreshData", null);
CustomerLabs = __decorate([
    Component({
        name: 'customer-labs',
        methods: {
            ...mapActions('labs', { fetchLabs: 'find' }),
        },
        components: {
            LabsList,
        },
        computed: {
            ...mapState('labs', { isLoading: 'isFindPending' })
        }
    })
], CustomerLabs);
export default CustomerLabs;
